import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { FiHome, FiShoppingBag } from "react-icons/fi";

import MainContainer from "../../../components/utils/MainContainer";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <MainContainer>
      <Wrap>
        <Glow aria-hidden="true" />
        <Code aria-hidden="true">
          4<span>0</span>4
        </Code>
        <Title>Stranica nije pronađena</Title>
        <Text>
          Stranica <Path>{location.pathname}</Path> ne postoji ili je
          premeštena. Proveri adresu ili se vrati na početnu.
        </Text>
        <Actions>
          <Primary onClick={() => navigate("/")}>
            <FiHome size={18} /> Početna
          </Primary>
          <Ghost onClick={() => navigate("/prodavnica")}>
            <FiShoppingBag size={18} /> Prodavnica
          </Ghost>
        </Actions>
      </Wrap>
    </MainContainer>
  );
};

export default NotFoundPage;

const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

const Wrap = styled.section`
  position: relative;
  min-height: 72vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 4rem 1.5rem 5rem;
  overflow: hidden;
`;

const Glow = styled.div`
  position: absolute;
  top: 12%;
  left: 50%;
  width: min(560px, 90vw);
  height: min(560px, 90vw);
  transform: translateX(-50%);
  background: radial-gradient(
    circle,
    rgba(255, 107, 53, 0.16),
    transparent 62%
  );
  pointer-events: none;
`;

const Code = styled.div`
  position: relative;
  font-family: var(--font-display, "Archivo Black", sans-serif);
  font-weight: 900;
  font-size: clamp(6rem, 26vw, 13rem);
  line-height: 0.95;
  color: var(--text-primary, #f5f2ef);
  letter-spacing: 0.02em;
  text-shadow: 0 0 48px rgba(255, 107, 53, 0.28);
  animation: ${float} 4.5s ease-in-out infinite;

  span {
    color: var(--brand, #ff6b35);
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Title = styled.h1`
  position: relative;
  font-family: var(--font-display, "Archivo Black", sans-serif);
  text-transform: uppercase;
  font-size: clamp(1.4rem, 5vw, 2.2rem);
  color: var(--text-primary, #f5f2ef);
  margin: 0.75rem 0 0.75rem;
  letter-spacing: 0.01em;
`;

const Text = styled.p`
  position: relative;
  color: var(--text-secondary, #b8b2ac);
  font-size: 1rem;
  max-width: 460px;
  line-height: 1.65;
  margin: 0 0 2.25rem;
`;

const Path = styled.code`
  color: var(--brand, #ff6b35);
  background: var(--brand-dim, rgba(255, 107, 53, 0.14));
  padding: 0.12rem 0.45rem;
  border-radius: 6px;
  font-size: 0.9em;
  word-break: break-all;
`;

const Actions = styled.div`
  position: relative;
  display: flex;
  gap: 0.85rem;
  flex-wrap: wrap;
  justify-content: center;
`;

const baseBtn = `
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  height: 48px;
  padding: 0 1.5rem;
  border-radius: var(--radius-control, 8px);
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.18s ease;
`;

const Primary = styled.button`
  ${baseBtn}
  background: var(--brand, #ff6b35);
  color: #ffffff;
  border: none;

  &:hover {
    background: var(--brand-hover, #e55a2b);
    transform: translateY(-2px);
  }
`;

const Ghost = styled.button`
  ${baseBtn}
  background: rgba(255, 255, 255, 0.05);
  color: var(--text-primary, #f5f2ef);
  border: 1px solid var(--border-strong, rgba(255, 255, 255, 0.12));
  font-weight: 600;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
  }
`;
